import {useCallback} from 'react';

import {useGetDataSection} from 'src/hooks/common-data-service/data-section';
import {getProfileChangeEvent} from 'src/openapi/admin/apis/ProfileChangeHistoryApi';
import {useAppDispatch} from 'src/store/hooks';

import {profileHistoryRecordActions, selectProfileHistoryRecord} from '../slices/profile-history-record.slice';

type Props = {
    profileId: number,
    recordId: number,
};

export const useGetProfileHistoryRecord = ({profileId, recordId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getAction = useCallback(() => apiDispatch(getProfileChangeEvent({
        profileId,
        eventId: recordId,
    })), [profileId, recordId, apiDispatch]);

    return useGetDataSection({selector: selectProfileHistoryRecord, actions: profileHistoryRecordActions, getAction});
};
